import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useFieldArray, useFormState } from "react-hook-form";
import { useIntl } from "react-intl";
import FieldHeader from "forms/fields/Languages/FieldHeader";
import LanguagesField from "forms/fields/Languages/LanguagesField";
import LanguagesLevelField from "forms/fields/Languages/LanguagesLevelField";
import type { FormControlType } from "types/formType";
import type { IProperty } from "types/jsonSchema";
import { predefinedFields } from "types/predefinedFields";
import { Fieldset } from "ui/Fieldset";
import { Button } from "uiShadcn/button";
import { FormError } from "uiShadcn/form";
export interface LanguagesProps {
  control: FormControlType;
  jsonData: Record<string, IProperty>;
}
export default function Languages(t0) {
  const $ = _c(38);
  const {
    control,
    jsonData
  } = t0;
  const isAppendedRef = useRef(false);
  const {
    formatMessage
  } = useIntl();
  const langs = jsonData?.languages;
  const isRequired = !!langs?.minProperties;
  const {
    errors
  } = useFormState();
  let t1;
  if ($[0] !== control) {
    t1 = {
      name: predefinedFields.languages,
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fields,
    append,
    remove
  } = useFieldArray(t1);
  let t2;
  if ($[2] !== append || $[3] !== fields.length) {
    t2 = () => {
      if (fields?.length === 0 && !isAppendedRef.current) {
        isAppendedRef.current = true;
        append({
          level: "",
          language: ""
        }, {
          shouldFocus: false
        });
      }
    };
    $[2] = append;
    $[3] = fields.length;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== append || $[6] !== fields) {
    t3 = [append, fields];
    $[5] = append;
    $[6] = fields;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== formatMessage) {
    t4 = formatMessage({
      id: "languages"
    });
    $[8] = formatMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== control || $[11] !== fields || $[12] !== isRequired || $[13] !== langs?.additionalProperties || $[14] !== langs?.propertyNames || $[15] !== remove) {
    let t6;
    if ($[17] !== control || $[18] !== fields.length || $[19] !== isRequired || $[20] !== langs?.additionalProperties || $[21] !== langs?.propertyNames || $[22] !== remove) {
      t6 = (field, index) => <div key={field.id} className="flex flex-col gap-n2"><FieldHeader index={index} showRemoveButton={fields?.length > 1} onRemoveClick={() => remove(index)} /><LanguagesField control={control} index={index} isRequired={isRequired} enumNames={langs?.propertyNames?.["x-enumNames"] ?? []} enumValues={langs?.propertyNames?.enum ?? []} /><LanguagesLevelField control={control} index={index} isRequired={isRequired} enumNames={langs?.additionalProperties?.["x-enumNames"] ?? []} enumValues={langs?.additionalProperties?.enum ?? []} /></div>;
      $[17] = control;
      $[18] = fields.length;
      $[19] = isRequired;
      $[20] = langs?.additionalProperties;
      $[21] = langs?.propertyNames;
      $[22] = remove;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t5 = fields.map(t6);
    $[10] = control;
    $[11] = fields;
    $[12] = isRequired;
    $[13] = langs?.additionalProperties;
    $[14] = langs?.propertyNames;
    $[15] = remove;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[24] !== errors) {
    t6 = errors?.[predefinedFields.languages]?.message && <FormError>{errors[predefinedFields.languages]?.message as string}</FormError>;
    $[24] = errors;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== append) {
    t7 = () => append({
      level: "",
      language: ""
    });
    $[26] = append;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== formatMessage) {
    t8 = formatMessage({
      id: "add"
    });
    $[28] = formatMessage;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t7 || $[31] !== t8) {
    t9 = <Button type="button" onClick={t7} dataTestId="AddLang" className="mr-auto" variant="grey" size="md">{t8}</Button>;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t4 || $[34] !== t5 || $[35] !== t6 || $[36] !== t9) {
    t10 = <Fieldset title={t4}>{t5}{t6}{t9}</Fieldset>;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}